import { createSelector } from "reselect";
const selector = (state) => state.roles;

export default createSelector([selector], (data) => data);